// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FolderOpenTwoToneSvg from "@fishx/icons-svg/es/asn/FolderOpenTwoTone";
import FishxIcon from '../components/FishxIcon';

var FolderOpenTwoTone = function FolderOpenTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FolderOpenTwoToneSvg
  }));
};

FolderOpenTwoTone.displayName = 'FolderOpenTwoTone';
export default React.forwardRef(FolderOpenTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FolderOpenTwoTone.js
// module id = 2803
// module chunks = 0